import { Storage } from "@faire/web--source/common/Storage";
import { useCallback, useEffect } from "react";
var FORM_DATA_KEY = "MAKER_INBOUND_APPLICATION_FORM_DATA";
export var MAKER_APPLICATION_DEFAULT_FORM_DATA = {
    country: {
        isoCode: "",
        displayName: ""
    }
};
export var useMakerApplicationDataForm = function(defaultData) {
    var getFormData = useCallback(function() {
        var data = Storage.local.getItem(FORM_DATA_KEY);
        return data ? JSON.parse(data) : undefined;
    }, []);
    var setData = useCallback(function(data) {
        Storage.local.setItem(FORM_DATA_KEY, JSON.stringify(data));
    }, []);
    var clearData = useCallback(function() {
        if (getFormData()) {
            Storage.local.removeItem(FORM_DATA_KEY);
        }
    }, [
        getFormData
    ]);
    useEffect(function() {
        if (defaultData) {
            setData(defaultData);
        }
    }, [
        defaultData,
        setData
    ]);
    return {
        getFormData: getFormData,
        setData: setData,
        clearData: clearData
    };
};
